import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { getNumberOfOffers } from '../../../helpers/getNumberOfOffers'
import { setFilterParams } from '../../../helpers/setFilterParams'
import store from '../../../store'
import {
  FetchLayoutsRequest,
  resetLayoutsFilter,
  SetLayoutsFilter,
} from '../../../store/layouts/actions'
import { getLayouts } from '../../../store/layouts/layouts'
import { LayoutsStateType } from '../../../store/layouts/types'
import { getProject } from '../../../store/project/project'
import { Button } from '../../UI/Button/Button'
import { CheckBoxButton } from '../../UI/CheckBoxButton/CheckBoxButton'
import InputRange from '../../UI/InputRange/InputRange'
import styles from './projectFilters.module.scss'
import { ProjectFiltersTypes } from './ProjectFilters.types'

export const ProjectFilters = ({ id }: ProjectFiltersTypes) => {
  const { layouts, filters }: LayoutsStateType = useSelector(getLayouts)
  const { project } = useSelector(getProject)
  const navigate = useNavigate()

  const handleCheckbox = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const name = e.target.name
    let value: string | null | {} = e.target.checked ? e.target.value : null

    if (name === 'rooms') {
      value = e.target.checked
        ? { ...filters.rooms, [e.target.value]: true }
        : { ...filters.rooms, [e.target.value]: null }
    }

    store.dispatch(SetLayoutsFilter({ name, value }))
  }

  const handleRange = (value: number | number[], name?: string) => {
    if (Array.isArray(value)) {
      store.dispatch(SetLayoutsFilter({ name: `${name}from`, value: value[0] }))
      store.dispatch(SetLayoutsFilter({ name: `${name}to`, value: value[1] }))
    }
  }

  useEffect(() => {
    if (id) {
      store.dispatch(FetchLayoutsRequest({ id }))
    }
  }, [filters])

  useEffect(() => {
    store.dispatch(resetLayoutsFilter())
  }, [id])

  return (
    <div className={styles.filterWrapper}>
      <div className={styles.roomsFilter}>
        <CheckBoxButton
          label={'Студия'}
          value={'studio'}
          width='112px'
          borderRadius='32px'
          onChange={handleCheckbox}
          name={'rooms'}
          checked={filters.rooms?.studio ? true : false}
        />
        <CheckBoxButton
          label={'1'}
          value={'1'}
          width='48px'
          borderRadius='100%'
          onChange={handleCheckbox}
          name={'rooms'}
          checked={filters.rooms?.[1] ? true : false}
        />
        <CheckBoxButton
          label={'2'}
          value={'2'}
          width='48px'
          borderRadius='100%'
          onChange={handleCheckbox}
          name={'rooms'}
          checked={filters.rooms?.[2] ? true : false}
        />
        <CheckBoxButton
          label={'3+'}
          value={'more'}
          name={'rooms'}
          width='48px'
          borderRadius='100%'
          onChange={handleCheckbox}
          checked={filters.rooms?.more ? true : false}
        />
      </div>
      {project && (
        <InputRange
          name='price-'
          rangeValue={[project.prices.from, project.prices.to]}
          onChange={handleRange}
          project={project}
        />
      )}

      <div className={styles.result}>
        {layouts?.project !== undefined && (
          <Button
            disabled={layouts?.project.items.length ? false : true}
            onClick={() => navigate(`/flats/${id}${setFilterParams()}`)}
            content={getNumberOfOffers(layouts?.project.nav.RECORD_COUNT)}
          ></Button>
        )}
      </div>
    </div>
  )
}
